<template>
    <div>
        <div class="mb-2 d-none d-md-flex justify-content-end">
          <b-button size="sm" variant="primary" @click="showUpload = true">
            <b-icon icon="upload"></b-icon> Tải dữ liệu
          </b-button>
        </div>
         <table-view
            :columns="columns"
            :display_columns="display_columns"
            :filters="filters"
            :table_name="table_name"
            :sorts="sorts"
            @row-clicked="rowClicked"
             ref="tableview"
        >
        </table-view>

        <upload-dialog :show="showUpload" modal-id="upload-online-scan" @close="showUpload = false" @imported="onImported" />
    </div>
</template>

<script>

import TableMeta from '@/models/OnlineScanTableMeta'
import GenericTableView from '@/views/base/GenericTableView'
import UploadDialog from '@/views/base/UploadDialog'

export default {
  name: 'OnlineScan',
  components: {
      'table-view': GenericTableView,
      'upload-dialog': UploadDialog
  },
  data () {
    return {
      display_columns: TableMeta.list_views.columns,
        columns: TableMeta.columns,
        filters: TableMeta.list_views.filters,
        table_name: TableMeta.table_name,
        sorts: TableMeta.list_views.sorts,
        showUpload: false
    }
  },
  
  methods: {
    rowClicked (event) {
        console.log('outside clicked event ', event.id);
        let routeData = this.$router.resolve({path: `/v2/online_scan/${event.id}/view`});
        window.open(routeData.href, '_blank');
    },
    onImported () {
      // refresh the table after import
      this.$bvToast && this.$bvToast.toast('Đã xử lý tải dữ liệu', { title: 'Upload', variant: 'success', autoHideDelay: 1500 });
      if (this.$refs.tableview) {
        this.$refs.tableview.refreshData(true);
      }
    }
  },
  props: [],
  mounted () {
  }
}
</script>

<style scoped>
</style>
